import {
    Route,
    Routes,
} from 'react-router-dom';

import {IndexPage} from './pages/IndexPage';
import {ConfirmPage} from "./pages/ConfirmPage.tsx";
// REGISTRATION-PAUSE (FNP-1222) — TEMPORARY: remove these two imports and the
// guard below to restore the sign-up routes. See src/config/registration.ts.
import {RegistrationClosedPage} from './pages/RegistrationClosedPage';
import {isRegistrationEnabled} from '../../../config/registration';

export const SignUpLayout = () => {

    // REGISTRATION-PAUSE (FNP-1222): closes the whole sign-up chain, including
    // /sign-up/confirm, so a direct URL or an inbound deep link from another
    // property lands on the closed state rather than the form.
    if (!isRegistrationEnabled()) {
        return (
            <Routes>
                <Route
                    path='*'
                    element={<RegistrationClosedPage/>}
                />
            </Routes>
        );
    }

    return (
        <Routes>
            <Route
                path='/'
                element={<IndexPage/>}
            />
            <Route
                path='confirm'
                element={<ConfirmPage/>}
            />
        </Routes>
    );
};
